var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHello = function SvgHello(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.77995 4.8C11.1303 4.8 12.2249 3.72548 12.2249 2.4C12.2249 1.07452 11.1303 0 9.77995 0C8.42962 0 7.33496 1.07452 7.33496 2.4C7.33496 3.72548 8.42962 4.8 9.77995 4.8Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5355 7.332C14.0587 6.864 13.2396 6 11.6504 6C11.3936 6 9.91442 6 8.54523 6C5.18337 5.988 2.44499 3.3 2.44499 0H0C0 3.792 2.57946 7.008 6.11247 8.052V24H8.55746V16.8H11.0024V24H13.4474V9.66L18.2763 14.4L20 12.708L14.5355 7.332Z",
    fill: "currentColor"
  })));
};
export default SvgHello;